<script>
    import { navigateTo } from 'svelte-router-spa';
    import { Circle } from 'svelte-loading-spinners';
    import { Constans } from '../../lib/Constants';
    import { t, locale, locales } from "../../../scripts/i18n";

    export let stage = {};
    export let setStage;

    export let startAnalyze;

    let isStarting = false;

    function start(event) {
        isStarting = true;

        setTimeout(() => {
            isStarting = false;
            startAnalyze();
        }, 1000);
    }
</script>

<div class="banner-wrap">
    <div class="banner-intro">
        {$t("Start scan and cleaning of your Instagram account real-time")}
    </div>

    <div class="btn-wrap">
        <a href="#" on:click={(e) => start(e)} class="display-inline-block lh-45px pulse-button mx-auto purple-btn purple-btn_hover w-190px h-45px mb-10px">
            <span class="display-flex-center">
                {$t("Scan")}
            {#if isStarting}
                <span class="ml-10px display-inline-block">
                    <Circle size="19" color="#FFF" unit="px" duration="1s" />
                </span>
            {/if}
            </span>
        </a>
        <a href="/demo/clean-finished" class="display-inline-block lh-45px mx-auto purple-btn purple-btn_hover w-190px h-45px mr-20px">
            {$t("Report")}
        </a>
    </div>
</div>

<style>
    .display-flex-center {
        display: flex;
        justify-content: center;
        align-items: center;
    }
</style>